module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("85Udv"))).then(() => parcelRequire('ljYL6'));